import { z } from "zod";
import { PreliminaryReportSchema } from "./PreliminaryReport";

export const PreliminaryReportRequestSchema = PreliminaryReportSchema.pick({
    description: true
});

export type PreliminaryReportRequest = z.infer<typeof PreliminaryReportRequestSchema>;
